import type { FaireProductEntity } from "../../entity_types/product";

export const p_nefz3u9a87: FaireProductEntity = {
  token: "p_nefz3u9a87",
  type: "product",
  name: "30\" x 630' Bogus Paper Roll for Void Fill",
  brandToken: "b_ajaj2rm3ar",
  brandName: "Store Supply Warehouse",
  imageUrl: "https://cdn.faire.com/fastly/6fbdf3ece45ed93dcff88560abe395240511e13122516e3d3e0c6a2d5d302a1f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6686ca40e4ca925046e3fafdc1e4c6d5c9f4bc1723ec7cb45d57e950eeaf0407.jpeg",
    "https://cdn.faire.com/fastly/6b2a62ec4779b2570c1f70f13fcc5a499a680aa041fc1df1f01648be6bac1dbb.jpeg",
    "https://cdn.faire.com/fastly/6c89e1036a4a6047686399d4568510717941d36c4eaf3e2efba592af00f957d6.jpeg"
  ],
  priceDollars: 45,
  description: "An economical void-fill paper for everyday packing. Crumple, fold or layer it around products to fill empty space in cartons, reduce movement and add cushioning in transit.\n\n- Roll size: 30\" wide x 630' long\n- Tear off just the amount you need\n- Works for items of many shapes and sizes\n\nA practical packing staple for online sellers, retail backrooms and fulfillment areas.",
  tags: [],
  msrpDollars: 67.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:05:19.322Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
